import Pill from 'common/components/pills/pill';
import {
  SegmentFilter,
  SegmentFilterBeingEditedChangedPayload,
  SegmentFilterDeletedPayload
} from '../../segment-controls.types';
import TooltipLegacy from 'common/components/tooltip/tooltip-legacy';
import { PillTheme } from 'common/components/pills/pill-theme';
import { useDispatch } from 'react-redux';
import {
  onSegmentFilterBeingEditedChanged,
  onSegmentFilterDeleted
} from '../../segment-controls.slice';
import { SegmentControlsFilterValueOperators } from 'features/segment-controls/constants/segment-controls-filter-value-operators';

interface SegmentControlFilterPillProps {
  componentId: string;
  filter: SegmentFilter;
}

const SegmentFilterPill = ({
  filter,
  componentId
}: SegmentControlFilterPillProps) => {
  const dispatch = useDispatch();

  const onEditFilter = () => {
    const payload: SegmentFilterBeingEditedChangedPayload = {
      componentId,
      segmentFilter: filter
    };
    dispatch(onSegmentFilterBeingEditedChanged(payload));
  };

  const onDeleteFilter = () => {
    const payload: SegmentFilterDeletedPayload = {
      segmentFilterId: filter.id,
      componentId
    };

    dispatch(onSegmentFilterDeleted(payload));
  };

  const containsValues = filter.values
    .filter(
      (filter) =>
        filter.valueOperator === SegmentControlsFilterValueOperators.CONTAINS
    )
    .map((filter) => filter.value);

  const equalsValues = filter.values
    .filter(
      (filter) =>
        filter.valueOperator === SegmentControlsFilterValueOperators.EQUALS
    )
    .map((filter) => filter.value);

  return (
    <Pill theme={PillTheme.SCHEDULED}>
      <div className="flex items-center p-2">
        {containsValues.length > 0 && (
          <div>
            <span>Contains: (</span>
            {containsValues.map((value, index) => (
              <span key={index}>
                {value}
                {index < containsValues.length - 1 && (
                  <span className="text-xxs mr-1"> OR</span>
                )}
              </span>
            ))}
            <span>)</span>
          </div>
        )}
        {equalsValues.length > 0 && (
          <div>
            {containsValues.length > 0 && (
              <span className="text-xxs ml-1 mr-1">OR</span>
            )}
            <span>Equals: (</span>
            {equalsValues.map((value, index) => (
              <span key={index}>
                {value}
                {index < equalsValues.length - 1 && (
                  <span className="text-xxs mr-1"> OR</span>
                )}
              </span>
            ))}
            <span>)</span>
          </div>
        )}
        <button
          id={`edit-filter-${filter.id}`}
          className="relative group flex items-center mx-2"
          onClick={onEditFilter}
        >
          <TooltipLegacy positionClasses="bottom-6 left-1/2 -translate-x-1/2">
            <div className="whitespace-nowrap">Edit filter</div>
          </TooltipLegacy>
          <i className="ra-icons-generic-edit flex text-xs"></i>
        </button>
        <button
          id={`delete-filter-${filter.id}`}
          className="relative group flex items-center"
          onClick={onDeleteFilter}
        >
          <TooltipLegacy positionClasses="bottom-6 left-1/2 -translate-x-1/2">
            <div className="whitespace-nowrap">Delete filter</div>
          </TooltipLegacy>
          <i className="ra-icons-generic-close-1 flex text-xxs"></i>
        </button>
      </div>
    </Pill>
  );
};

export default SegmentFilterPill;
